const apiRoot = 'https://v0.avaamo.com/api';

export const postAudio = (audio, prompt, textFileName, uuid) => {
  return fetch(`${apiRoot}/api/audio/?uuid=${uuid}&prompt=${prompt}&textFileName=${textFileName}`, {
    method: 'POST',
    body: audio,
    headers: {
      'Content-Type': 'audio/wav'
    }
  })
};

export const getUserAudioList = (uuid) => {
  return fetch(`${apiRoot}/api/audio/?uuid=${uuid}`, {
    method: 'GET'
  })
};

export const getUserAudioFile = (uuid, audio_id) => {
  return `${apiRoot}/api/audio/?uuid=${uuid}&audio_id=${audio_id}`
};

export const getPrompt = (uuid, groupName) => {
  return fetch(`${apiRoot}/api/prompt/?uuid=${uuid}&groupName=${groupName}`, {
    method: 'GET'
  });
};

export const getUser = (name, groupName) => {
  return fetch(`${apiRoot}/api/user/?name=${name}&groupName=${groupName}`, {
    method: 'GET'
  })
}

export const getAudioLen = (uuid, audio) => {
  return fetch(`${apiRoot}/api/audio/?uuid=${uuid}&get_len=True`, {
    method: 'POST',
    body: audio,
    headers: {
      'Content-Type': 'audio/wav'
    }
  })
}

export const createUser = (uuid, name, groupName) => {
  const data = {
    uuid: uuid,
    user_name: name,
    groupName: groupName
  }

  return fetch(`${apiRoot}/api/user/`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
}

export const getSpeakers = () => {
  return fetch(`${apiRoot}/api/speak/`, {
    method: 'GET'
  })
}

export const getSpeechBlob = (speaker, speakerIdx, userText) => {
  const data = {
    speaker: speaker,
    speakerIdx: speakerIdx,
    userText: userText
  }

  return fetch(`${apiRoot}/api/speak/`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then(res => {
      if (!res.ok) {
        return { "success": false, "data": null }
      }

      const reader = res.body.getReader();
      const chunks = [];

      return pump();

      function pump() {
        return reader.read().then(({ done, value }) => {
          if (done) {
            return { "success": true, "data": chunks }
          }
          chunks.push(value);
          return pump();
        });
      }
    })


}



// WEBPACK FOOTER //
// ./src/App/api/index.js